import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';

import {
  LOCAL_SERVICE_AREA_RADIUS_KM,
  SERVICE_AREAS,
  USER_ROLE_TYPES,
} from '../../../../../../constants';
import styles from './styles';
import {
  selectBuilderProjectGallery,
  selectRegistrationInfo,
} from '../../../../../../store/selectors';
import { imageHandler } from '../../../FieldsGroupTwo';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    header: PropTypes.string,
    main: PropTypes.string,
    actionsRow: PropTypes.string,
    inner: PropTypes.string,
  }).isRequired,
  registrationInfo: PropTypes.object.isRequired,
};

export const StepTwo = props => {
  const { classes, registrationInfo, builderProjectGallery } = props;

  const [builderProfilePhoto, setBuilderProfilePhoto] = React.useState();
  const [builderBannerPhoto, setBuilderBannerPhoto] = React.useState();

  const isBuilder =
    registrationInfo['custom:roleType'] === USER_ROLE_TYPES.BUILDER.code;
  console.log({ registrationInfo });

  const renderDetailItem = (label, key) => {
    const value = () => {
      if (registrationInfo[key]) {
        if (
          typeof registrationInfo[key] === 'boolean' &&
          registrationInfo[key] === true
        ) {
          return 'Yes';
        }
        return registrationInfo[key];
      }
      if (
        typeof registrationInfo[key] === 'boolean' &&
        registrationInfo[key] === false
      ) {
        return 'No';
      }
      return 'N/A';
    };
    return (
      <>
        <div className={classes.detailItemLabel}>{label}</div>
        <div className={classes.detailItemContent}>{value()}</div>
      </>
    );
  };

  const serviceArea = () => {
    if (registrationInfo['custom:serviceAType'] === SERVICE_AREAS.NATIONAL) {
      return (
        <>
          <div className={classes.detailItem}>
            <div className={classes.detailItemLabel}>Service Area</div>
            <div className={classes.detailItemContent}>National</div>
          </div>
          <div className={classes.detailItem}>
            <div className={classes.detailItemLabel}>Country</div>
            <div className={classes.detailItemContent}>Australia</div>
          </div>
        </>
      );
    }
    if (registrationInfo['custom:serviceAType'] === SERVICE_AREAS.STATEWIDE) {
      return (
        <>
          <div className={classes.detailItem}>
            <div className={classes.detailItemLabel}>Service Area</div>
            <div className={classes.detailItemContent}>State Wide</div>
          </div>
          <div className={classes.detailItem}>
            <div className={classes.detailItemLabel}>State</div>
            <div className={classes.detailItemContent}>
              {registrationInfo['custom:serviceAState']}
            </div>
          </div>
          <div className={classes.detailItem}>
            <div className={classes.detailItemLabel}>Country</div>
            <div className={classes.detailItemContent}>Australia</div>
          </div>
        </>
      );
    }
    if (registrationInfo['custom:serviceAType'] === SERVICE_AREAS.LOCAL) {
      return (
        <>
          <div className={classes.detailItem}>
            <div className={classes.detailItemLabel}>Business Address</div>
            <div className={classes.detailItemContent}>
              {registrationInfo['custom:serviceAAdd']}
            </div>
          </div>
          <div className={classes.detailItem}>
            <div className={classes.detailItemLabel}>Country</div>
            <div className={classes.detailItemContent}>Australia</div>
          </div>
          <div className={classes.detailItem}>
            <div className={classes.detailItemLabel}>Service Area</div>
            <div className={classes.detailItemContent}>Local</div>
          </div>
          <div className={classes.detailItem}>
            <div className={classes.detailItemLabel}>
              LOCAL SERVICE AREA RADIUS
            </div>
            <div className={classes.detailItemContent}>
              {LOCAL_SERVICE_AREA_RADIUS_KM.toString()}km
            </div>
          </div>
        </>
      );
    }
    return null;
  };

  React.useEffect(() => {
    if (registrationInfo) {
      if (registrationInfo.logo) {
        imageHandler(registrationInfo.logo, setBuilderProfilePhoto);
      }
      if (registrationInfo.coverPhoto) {
        imageHandler(registrationInfo.coverPhoto, setBuilderBannerPhoto);
      }
    }
  }, [registrationInfo]);

  return (
    <div>
      <div className={classes.instruction}>
        Please review your details and submit your application
      </div>
      <div className={classes.detailsContainer}>
        <div className={classes.firstRow}>
          <div className={classes.detailsGroupOne}>
            <h2 className={classes.detailsGroupHeading}>Your details</h2>
            <div className={classes.detailsGroupBody}>
              {isBuilder && (
                <div className={classes.detailItemRow}>
                  <div className={classes.detailItem}>
                    {renderDetailItem(
                      'Your Builder Licence Number',
                      'custom:buildingLicNo',
                    )}
                  </div>
                </div>
              )}
              {isBuilder && (
                <div className={classes.detailItemRow}>
                  <div className={classes.detailItem}>
                    {renderDetailItem(
                      'Your Builder Licence Expiry Date',
                      'custom:buildingLicExpMask',
                    )}
                  </div>
                </div>
              )}
              <div className={classes.detailItemRow}>
                <div className={classes.detailItem}>
                  {renderDetailItem(
                    'Your Email Address',
                    'custom:personalEmail',
                  )}
                </div>
              </div>
              <div className={classes.detailItemRow}>
                <div className={classes.detailItem}>
                  {renderDetailItem(
                    'Your Primary Contact Number',
                    'custom:personalPhone',
                  )}
                </div>
              </div>
              <div className={classes.detailItemRow}>
                <div className={classes.detailItem}>
                  {renderDetailItem(
                    'Your Mobile Number',
                    'custom:mobileNumber',
                  )}
                </div>
              </div>
              <div className={classes.detailItemRow}>
                <div className={classes.detailItem}>
                  {renderDetailItem('Show In Search', 'showInSearch')}
                </div>
              </div>
            </div>
          </div>
          <div className={classes.detailsGroupTwo}>
            <h2 className={classes.detailsGroupHeading}>Business details</h2>
            <div className={classes.detailsGroupBody}>
              <div className={classes.detailItemRow}>
                <div className={classes.detailItemHalf}>
                  {renderDetailItem('Business Name', 'custom:businessName')}
                </div>
                <div className={classes.detailItemHalf}>
                  {renderDetailItem('Position', 'custom:position')}
                </div>
              </div>
              <div className={classes.detailItemRow}>
                <div className={classes.detailItem}>
                  {renderDetailItem(
                    'Profile Description',
                    'custom:profileHeadline',
                  )}
                </div>
              </div>
              {isBuilder && (
                <div className={classes.detailItemRow}>
                  <div className={classes.detailItem}>
                    <div className={classes.detailItemLabel}>Logo</div>
                    <div className={classes.detailItemContent}>
                      {builderProfilePhoto && (
                        <img
                          alt="Profile"
                          src={builderProfilePhoto}
                          className={classes.photoUpload}
                        />
                      )}
                    </div>
                  </div>
                  <div className={classes.detailItem}>
                    <div className={classes.detailItemLabel}>Cover Photo</div>
                    <div className={classes.detailItemContent}>
                      {builderBannerPhoto && (
                        <img
                          alt="banner"
                          src={builderBannerPhoto}
                          className={classes.photoUpload}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className={classes.detailItemRow}>
                <div className={classes.detailItem}>
                  {renderDetailItem(
                    'Business Mailing Address',
                    'custom:businessAddress',
                  )}
                </div>

                <div className={classes.detailItem}>
                  {renderDetailItem(
                    'Where do you plan to purchase James Hardie products for your next project?',
                    'custom:materialLocation',
                  )}
                </div>
              </div>
              {isBuilder && (
                <div className={classes.detailItem}>
                  <div className={classes.detailItemLabel}>Project Gallery</div>

                  <div
                    className={`${classes.detailItemContent} ${
                      classes.galleryImages
                    }`}
                  >
                    {builderProjectGallery &&
                      builderProjectGallery.length > 0 &&
                      builderProjectGallery.map(image => (
                        <div className={classes.imageContainer}>
                          <img
                            src={image.image}
                            alt="project-gallery"
                            className={classes.photoUpload}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              )}
              {isBuilder && (
                <div className={classes.detailItemRow}>
                  <div className={classes.detailItemHalf}>
                    {renderDetailItem('Build Type', 'custom:skillsetBuild')}
                  </div>
                  <div className={classes.detailItemHalf}>
                    {renderDetailItem('Looks', 'custom:skillsetLook')}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {isBuilder && (
          <div className={classes.detailsGroupThree}>
            <h2 className={classes.detailsGroupHeading}>Service Areas</h2>
            <div className={classes.detailsGroupBody}>
              <div className={classes.detailItemRow}>{serviceArea()}</div>
            </div>
          </div>
        )}
        {isBuilder && (
          <div className={classes.detailsGroupThree}>
            <h2 className={classes.detailsGroupHeading}>Additional Info</h2>
            <div className={classes.detailsGroupBody}>
              <div className={classes.detailItemRow}>
                {/* <div className={classes.detailItem}>
                  {renderDetailItem(
                    'Where do you plan to purchase James Hardie products for your next project?',
                    'custom:materialLocation',
                  )}
                </div> */}
                <div className={classes.detailItem}>
                  {renderDetailItem(
                    'Number of New Builds completed over the past year?',
                    'custom:newBuildsPerYear',
                  )}
                </div>
                <div className={classes.detailItem}>
                  {renderDetailItem(
                    'Number of Renovations completed over the past year?',
                    'custom:renovationsPerYear',
                  )}
                </div>
              </div>
              <div className={classes.detailItemRow}>
                <div className={classes.detailItem}>
                  {renderDetailItem(
                    'Number of permanent employees in your business?',
                    'custom:employeesCount',
                  )}
                </div>
                <div className={classes.detailItem}>
                  {renderDetailItem(
                    'Number of years your business has been open?',
                    'custom:businessYears',
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

StepTwo.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  registrationInfo: selectRegistrationInfo(),
  builderProjectGallery: selectBuilderProjectGallery(),
});

export default withStyles(styles)(connect(mapStateToProps)(StepTwo));
